import React from 'react';
import LeftForm from '../../Components/Forms/LeftForm';
import RightTable from '../../Components/Tables/RightTable';
import EmployeeForm from '../../Components/Forms/LeftFormInputs';

const leftColumns = [
  [
    {
      Header: 'Nom',
      accessor: 'name',
      inputType: 'text',
    },
    {
      Header: 'No employé',
      accessor: 'employee_number',
      inputType: 'text',
      required: true,
    },
    {
      Header: 'Notes',
      accessor: 'note',
      inputType: 'text',
    },
  ],
  [
    {
      Header: 'Contremaitre',
      accessor: 'is_captain',
      inputType: 'checkbox',
    },
    {
      Header: 'Type',
      accessor: 'employee_type',
      inputType: 'text',
    },
    {
      Header: 'Coché si disponible',
      accessor: 'available',
      inputType: 'checkbox',
    },
  ],
  [
    {
      Header: 'Courriel',
      accessor: 'email',
      inputType: 'text',
    },
  ],
];

const columns = [
  [
    {
      Header: 'Nom',
      accessor: 'name',
      inputType: 'text',
    },
    {
      Header: 'Type',
      accessor: 'employee_type',
      inputType: 'text',
    },
    {
      Header: 'Contremaitre',
      accessor: 'is_captain',
      inputType: 'checkbox',
      filterable: false,
      Cell: row => {
        return (
          <div className="bool">
            {row.original[row.column.id] ? 'Oui' : 'Non'}
          </div>
        );
      },
    },
    {
      Header: 'No',
      accessor: 'employee_number',
      inputType: 'text',
    },
    {
      Header: 'Disponible',
      accessor: 'available',
      inputType: 'checkbox',
      filterable: false,
      Cell: row => {
        return (
          <div className="bool">
            {row.original[row.column.id] ? 'Oui' : 'Non'}
          </div>
        );
      },
    },
  ],
];

const Employees = () => (
  <React.Fragment>
    <LeftForm title="Créer un nouvel employé" model="employees">
      <EmployeeForm model="employees" columns={leftColumns} />
    </LeftForm>
    <RightTable
      title="Liste d'employés"
      model="employees"
      columns={columns[0]}
    />
  </React.Fragment>
);

export default Employees;
